import styled from "styled-components";

import { SPACING } from "../../../utils/constants";

export const FailureSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  font-size: var(--text-base);
`;

export const FailureHeading = styled.h3`
  margin: 0;
  font-size: var(--text-base);
`;

export const FailureText = styled.p`
  margin: 0;
`;

export const FailureCode = styled.code`
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  overflow-wrap: anywhere;
`;

export const FailureMessage = styled.pre`
  margin: 0;
  padding: ${SPACING.sm}px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  font-size: var(--text-sm);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
